export default {
  nav: {
    categories: 'Kategorien',
    topSites: 'Top-Websites',
    compare: 'Vergleichen',
    submitSite: 'Website einreichen',
    about: 'Über uns',
    logIn: 'Anmelden',
  },
  common: {
    back: 'Zurück',
    search: 'Suche',
    loading: 'Wird geladen…',
    viewSimilarSites: 'Ähnliche Websites ansehen',
  },
  hero: {
    badge: 'Website-Entdeckungsmaschine',
    titleA: 'Finde Websites ähnlich wie',
    titleB: 'deine Favoriten.',
    titlePrefix: 'Finde Websites ähnlich wie',
    titleAccent: 'deine Favoriten.',
    subtitle: 'Entdecke Wettbewerber, Alternativen und versteckte Perlen im Web – mit präzisen Ähnlichkeitswerten.',
    placeholder: 'Domain eingeben (z. B. stripe.com)',
    inputPlaceholder: 'Domain eingeben (z. B. stripe.com)',
    step1Label: 'Domain eingeben',
    step1Desc: 'Gib eine Website-URL ein, um zu starten',
    step2Label: 'Treffer erhalten',
    step2Desc: 'Unsere Engine findet sofort ähnliche Seiten',
    step3Label: 'Vergleichen & entscheiden',
    step3Desc: 'Alternativen analysieren und vergleichen',
    steps: {
      step1Label: 'Domain eingeben',
      step1Desc: 'Gib eine Website-URL ein, um zu starten',
      step2Label: 'Treffer erhalten',
      step2Desc: 'Unsere Engine findet sofort ähnliche Seiten',
      step3Label: 'Vergleichen & entscheiden',
      step3Desc: 'Alternativen analysieren und vergleichen',
    },
  },
  footer: {
    newsletterTitle: 'Bleib auf dem Laufenden',
    newsletterDesc: 'Wöchentliche Updates zu trendenden Websites und neuen Alternativen.',
    emailPlaceholder: 'deine@email.de',
    subscribe: 'Abonnieren',
    brandDesc: 'Entdecke verborgene Verbindungen im Web. Finde ähnliche Websites mit präziser Bewertung.',
    explore: 'Entdecken',
    popular: 'Beliebt',
    company: 'Unternehmen',
    compareSites: 'Websites vergleichen',
    sitesLike: 'Websites wie',
    contact: 'Kontakt',
    faq: 'FAQ',
    removeYourSite: 'Deine Website entfernen',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    rights: 'Alle Rechte vorbehalten.',
  },
  notFound: {
    title: 'Ups! Seite nicht gefunden',
    returnHome: 'Zur Startseite',
  },
  submitPage: {
    ctaTitle: 'Kennst du eine großartige Website?',
    ctaDesc: 'Hilf uns, unsere Datenbank zu erweitern, indem du Lieblingssites einreichst. Es dauert nur wenige Sekunden.',
    ctaButton: 'Website einreichen',
    pageTitle: 'Website einreichen',
    pageSubtitle: 'Reiche eine Website zur Aufnahme in unseren Index ein.',
    successTitle: 'Website eingereicht!',
    successReviewPrefix: 'Wir prüfen',
    successReviewSuffix: 'und nehmen die Seite bald in unseren Index auf.',
    backHome: 'Zur Startseite',
    domainLabel: 'Domain *',
    domainPlaceholder: 'z. B. example.com',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Kurze Beschreibung der Website',
    categoryLabel: 'Kategorie',
    categorySelect: 'Kategorie wählen',
    alternativeTo: 'Alternative zu (optional)',
    alternativeNone: 'Keine — keine Alternative',
    emailLabel: 'Deine E-Mail',
    emailPlaceholder: 'du@beispiel.de',
    submitButton: 'Website senden',
    submitFailed: 'Einreichen fehlgeschlagen',
    seoTitle: 'Website einreichen | CiteMatch',
    seoDesc: 'Reiche eine Website zur Aufnahme bei CiteMatch ein.',
  },
};

